import { configureStore } from '@reduxjs/toolkit';
import blockReducer from './blockSlice';
import friendReducer from './friendSlice'; // यहाँ import करें
import userReducer from './userSlice';

export const store = configureStore({
    reducer: {
        block: blockReducer,
        friend: friendReducer, 
        user: userReducer, 
    },
});